import { Component } from "react"
import PropTypes from "prop-types"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"
import { connectionShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import appletOrConnectionPath from "app/scripts/applet_or_connection_path"
import { Applet } from "types"

interface Props {
  applet: Applet,
  position: number
}

export default class MyServiceAppletCard extends Component<Props> {
  propTypes = {
    applet: connectionShape.isRequired,
    position: PropTypes.number.isRequired,
  }

  handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "discover_service",
      connection_status: this.props.applet.status,
      connection_type: this.props.applet.config_type,
      object_id: this.props.applet.id,
      object_type: "connection",
      position: this.props.position,
    })
  }

  render() {
    return (
      <li className="my-web-applet-card web-applet-card">
        <SmallAppletCard
          onAppletClick={this.handleOnClick}
          appletPath={appletOrConnectionPath(this.props.applet)}
          applet={this.props.applet}
        />
      </li>
    )
  }
}

MyServiceAppletCard.propTypes = {
  applet: connectionShape.isRequired,
  position: PropTypes.number.isRequired,
}
